module.exports = __webpack_public_path__ + "img/undraw_mathematics_4otb.4cb5b349.svg";